import { render } from "./PayButtons.vue?vue&type=template&id=c95f08ea&scoped=true"
import script from "./PayButtons.vue?vue&type=script&lang=js"
export * from "./PayButtons.vue?vue&type=script&lang=js"

import "./PayButtons.vue?vue&type=style&index=0&id=c95f08ea&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95f08ea"],['__file',"webpack-assets/vue/templates/product/catalog/parts/PayButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c95f08ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c95f08ea', __exports__)) {
    api.reload('c95f08ea', __exports__)
  }
  
  module.hot.accept("./PayButtons.vue?vue&type=template&id=c95f08ea&scoped=true", () => {
    api.rerender('c95f08ea', render)
  })

}


export default __exports__